import RsvpReport from './reports-rsvp'
import TNCReport from './reports-tnc'
import TrxReport from './reports-trx'
import SpecializeReport from './reports-specialize'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    RsvpReport.state,
    TNCReport.state,
    TrxReport.state,
    SpecializeReport.state
  ),
  mutations: Object.assign(
    RsvpReport.mutations,
    TNCReport.mutations,
    TrxReport.mutations,
    SpecializeReport.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/reports/index.js